<template>
  <div>
    <!-- Use pl colors -->
    <header class="card-header">
      <ul class="tabs" :style="{ width: headerWidth }">
        <li
          class="description_tab tab pointer ma0"
          v-for="tab in tabs"
          :key="tab"
          v-bind:class="{
            active: activeTab === tab,
          }"
          v-on:click="switchTab(tab)"
          :style="{ width: 100 / tabs.length + '%' }"
        >
          <pl-button
            class="tab-btn"
            v-bind:class="{
              'btn-active': activeTab === tab,
            }"
          >
            <slot :name="tabHeadSlotName(tab)">{{ tab }} </slot>
          </pl-button>
        </li>
        <li
          class="slider"
          :style="{ left: sliderPosition, width: 100 / tabs.length + '%' }"
          role="presentation"
        ></li>
      </ul>
    </header>
    <main class="card-body" :style="{ minHeight: minHeight }">
      <div class="tab-panel">
        <slot :name="tabPanelSlotName"> </slot>
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    props: {
      initialTab: String,
      tabs: Array,
      minHeight: String,
      headerWidth: String,
    },
    data() {
      return {
        activeTab: this.initialTab,
      };
    },
    computed: {
      tabPanelSlotName() {
        return `tab-panel-${this.activeTab}`;
      },
      sliderPosition() {
        return (
          (this.tabs.findIndex((x) => x === this.activeTab) * 100) /
            this.tabs.length +
          '%'
        );
      },
    },
    methods: {
      tabHeadSlotName(tabName) {
        return `tab-head-${tabName}`;
      },

      switchTab(tabName) {
        this.activeTab = tabName;
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'

  .tabs
    position: relative;
    background-color: #fff;
    margin: 0;
    padding: 1rem 0;
    list-style: none;
    display flex

  .tabs:after
    content: ' ';
    display: table;
    clear: both;

  .description_tab
    float: left;
    text-align: center;

  .slider
    position: absolute;
    top: 44px;
    left: 0;
    height: 2px;
    transition: left 0.2s;
    background-color: pl-ruby

  .content
    visibility: hidden;

  .content.active
    visibility: visible;
    width: 100%;
    text-align: center;

  .tab-btn.default
    margin: 0;
    width: 100%
    color: pl-charcoal
</style>

<style lang="stylus">
  .tabs .active .pl-button *
    transition: all 200ms ease
    font-weight: 700
</style>



// WEBPACK FOOTER //
// plTabs.vue?164dfd78